import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { FaNode, FaAws, FaPython, FaReact } from "react-icons/fa";
import {
  SiDocker,
  SiSupabase,
  SiDjango,
  SiFlask,
  SiMongodb,
  SiSelenium,
  SiNextdotjs,
} from "react-icons/si";

export const TimeLine = () => {
  const timelineData = [
    {
      icon: <SiSelenium />,
      title: "Selenium Automation Tester",
      subtitle: "Started as Manual Tester",
      content: "Began with manual testing and progressed to automated testing using Selenium.",
      iconStyle: { background: "#007BFF", color: "#fff" }
    },
    {
      icon: <SiMongodb />,
      title: "Pymongo",
      subtitle: "Database Management",
      content: "Developed scripts to interact with MongoDB databases.",
      iconStyle: { background: "#FFC107", color: "#fff" }
    },
    {
      icon: <FaPython />,
      title: "Boto3",
      subtitle: "AWS Python SDK",
      content: "Learned AWS services integration using Python for cloud operations.",
      iconStyle: { background: "#6C757D", color: "#fff" }
    },
    {
      icon: <SiDocker />,
      title: "Docker",
      subtitle: "Containerization",
      content: "Learned containerization and orchestration for deployment processes.",
      iconStyle: { background: "#DC3545", color: "#fff" }
    },
    {
      icon: <FaAws />,
      title: "AWS",
      subtitle: "Cloud Computing",
      content: "Worked with AWS Batch, EventBridge, and S3 for scalable solutions.",
      iconStyle: { background: "#20C997", color: "#fff" }
    },
    {
      icon: <SiFlask />,
      title: "Flask",
      subtitle: "Web Development",
      content: "Built CRUD applications and APIs for internal tools.",
      iconStyle: { background: "#F8F9FA", color: "black" }
    },
    {
      icon: <SiDjango />,
      title: "Django",
      subtitle: "Full-Stack Framework",
      content: "Learned Django for web development (Beginner level).",
      iconStyle: { background: "#E83E8C", color: "#fff" }
    },
    {
      icon: <FaReact />,
      title: "React.js",
      subtitle: "Frontend Development",
      content: "Maintained e-commerce websites and built various web applications.",
      iconStyle: { background: "#FD7E14", color: "#fff" }
    },
    {
      icon: <SiSupabase />,
      title: "Supabase",
      subtitle: "Backend as a Service",
      content: "Used Supabase for backend services in internal websites and applications.",
      iconStyle: { background: "#343A40", color: "#fff" }
    },
    {
      icon: <FaNode />,
      title: "Node.js",
      subtitle: "Server-Side JavaScript",
      content: "Maintained and enhanced e-commerce website modules.",
      iconStyle: { background: "#6F42C1", color: "#fff" }
    },
    {
      icon: <SiNextdotjs />,
      title: "Next.js",
      subtitle: "Full-Stack React Framework",
      content: "Currently working as part of the tech team at ChangeBegins.ai (Maaya Analytics), developing web applications using Next.js.",
      iconStyle: { background: "#28A745", color: "#fff" }
    }
  ];

  return (
    <div className="w-full">
      <VerticalTimeline lineColor="rgba(59, 130, 246, 0.4)">
        {timelineData.map((item, index) => (
          <VerticalTimelineElement
            key={index}
            className="vertical-timeline-element--work"
            contentStyle={{
              background: 'rgba(30, 41, 59, 0.8)',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(59, 130, 246, 0.3)',
              borderRadius: '20px',
              color: '#fff',
              boxShadow: '0 8px 32px rgba(59, 130, 246, 0.2)'
            }}
            contentArrowStyle={{
              borderRight: '7px solid rgba(59, 130, 246, 0.3)'
            }}
            iconStyle={item.iconStyle}
            icon={item.icon}
          >
            <h3 className="vertical-timeline-element-title text-xl font-bold mb-2" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
              {item.title}
            </h3>
            <h4 className="vertical-timeline-element-subtitle text-blue-300 mb-3 bg-gradient-to-r from-blue-300 to-cyan-300 bg-clip-text text-transparent" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
              {item.subtitle}
            </h4>
            <p className="text-gray-300" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
              {item.content}
            </p>
          </VerticalTimelineElement>
        ))}
      </VerticalTimeline>
    </div>
  );
};
